const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../../core/vault/ActionTypes");

const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const withSetURL = require("../../core/hoc/withSetURL");
const withContainerDims = require("../../core/hoc/withContainerDims");
const withOfficeErrorCatching = require("../../core/hoc/withOfficeErrorCatching");

const URLMake = require("../../../shared/URLMake");
const Slots = require("../../core/vault/Slots");
const LoadGuard = require("../../core/view/LoadGuard");
const Link = require("../../core/view/Link");
const ParentUtil = require("../util/ParentUtil");
const ProfileUtil = require("../../core/util/ProfileUtil");
const ReportStudentBody = require("../../school/ReportStudentBody");
const ActivityTabContent = require("../../core/view/ActivityTabContent");
const ReportProblems = require("../../school/ReportProblems");
const OfficeModal = require("../../office/modals/OfficeModal");
const StudentName = require("./StudentName");
const OfficeSummaryStats = require("../../report/OfficeSummaryStats");
const AvatarLinkGroup = require("./AvatarLinkGroup");
const AssetsUtil = require("../../core/util/AssetsUtil");
const ScrollUtil = require("../../core/util/ScrollUtil");
const PrivacyBanner = require("../../core/view/PrivacyBanner");
const OpsUser = require("../../core/vault/OpsUser");

const styles = require("./styles/PageParent.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withContainerDims(Component);
	Component = withVaultDispatch(Component);
	Component = withSetURL(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			const officeStudentData = Slots.getValue(
				vaultState,
				Slots.table.parentData()
			);
			return {
				parentData: officeStudentData,
			};
		},
		{forLoggedIn: true}
	);
	Component = withOfficeErrorCatching(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageParentStudent",

		propTypes: {
			user: PT.object.isRequired,
			forPrint: PT.bool,
			pageData: PT.object.isRequired,
			extra: PT.object,
			setNextScrollTo: PT.func.isRequired,

			// Injected by HOCs
			parentData: PT.object.isRequired,
			dispatch: PT.func.isRequired,
			setURL: PT.func.isRequired,
			containerDims: PT.shape({
				windowWidth: PT.number.isRequired,
			}).isRequired,
		},

		getInitialState: function() {
			if (_.get(this.props.parentData, "needsDataReload", false)) {
				this.props.dispatch({type: AT.PARENT_OFFICE_STUDENT_DATA_RELOAD});
			}
			return {
				filters: {},
				reactCrashed: false,
				showProblemModal: false,
				showProblemProps: null,
			};
		},

		vaultEvents: {
			showReportProblemModal: function(props) {
				this.setState({
					showProblemModal: true,
					showProblemProps: props,
				});
			},
		},

		componentDidUpdate: function(prevProps) {
			if (!_.isEqual(prevProps.pageData, this.props.pageData)) {
				this.onClose();
				ScrollUtil.scrollTo("top");
			}
		},

		onClose: function() {
			this.setState({
				showProblemModal: false,
				showProblemProps: null,
			});
		},

		filterBy: function(col, val) {
			const {pageData} = this.props;
			const filters = _.pick(pageData, ["grade", "chapter", "block", "typeID"]);
			if (filters[col] !== parseInt(val)) {
				filters[col] = val;
				if (col === "grade") {
					filters.chapter = null;
					filters.block = null;
					filters.typeID = null;
				} else if (col === "chapter") {
					if (filters.grade === "lab") {
						filters.typeID = val;
						filters.chapter = null;
					}
					filters.block = null;
				}
				this.props.setURL(
					URLMake.forParentStudent(
						pageData.studentID,
						_.extend({}, pageData, filters)
					)
				);
			}
			this.setState(filters);
		},

		renderTermsAndConditions: function() {
			if (!OpsUser.hasAcceptedTerms(this.props.user)) {
				return <PrivacyBanner pageType="report" />;
			}
			return;
		},

		renderLoaded: function() {
			const {parentData, user, pageData, forPrint} = this.props;
			const {studentID, grade, chapter, block, type, date, typeID} = pageData;

			const studentsData = ParentUtil.getStudentsWithActivity(parentData);
			const studentData = studentsData[studentID];
			const isSingleStudent = _.size(studentsData) === 1;

			const fitAvatars = ParentUtil.fitAvatars(this.props);

			let headerTitleClass = styles.headerContentFit;
			let linkClass = styles.studentLinksFit;
			if (fitAvatars) {
				headerTitleClass = styles.headerContent;
				linkClass = styles.studentLinks;
			}

			const totalTime = ProfileUtil.getDurationVeryShortString(
				ProfileUtil.getMinutesForTimeData(studentData.activity.totalTimeData)
			);

			let body = null;
			if (type === "progress") {
				body = (
					<ReportStudentBody
						user={user}
						studentID={studentID}
						gradeNumber={grade}
						chapterNumber={chapter}
						blockNumber={block}
						typeID={typeID}
						pageData={pageData}
						updateStudentFilter={this.filterBy}
						forParent={true}
						inActiveClasses={studentData.inActiveClasses}
					/>
				);
			} else if (type === "activity") {
				const activity = {
					day: date,
					toggleType: "minutes",
				};
				body = (
					<ActivityTabContent
						activity={activity}
						profileID={studentID}
						style={"office"}
						className={styles.calendarOuter}
						calendarClass={styles.calendar}
						dayDetailsClass={styles.dayDetails}
						noSound={true}
						viewType={"parent"}
					/>
				);
			}

			const problemModal = this.state.showProblemModal ? (
				<OfficeModal
					modalClass={styles.problemsModal}
					backdropWrapperClass={styles.problemsBackdropWrapper}
					backdropClass={styles.problemsBackdrop}
					closeClass={styles.modalClose}
					closeColor="white"
					onClose={this.onClose}
					closeOnEsc={true}
					portalContainer={null}
					level="overBar"
					closeOnBackdropClick={true}
					isScrollable={true}
					isFixed={true}
				>
					<ReportProblems
						user={user}
						{...this.state.showProblemProps}
						forParent={true}
						inActiveClasses={studentData.inActiveClasses}
					/>
				</OfficeModal>
			) : null;

			const progressClass =
				type === "progress" ? styles.selectedTab : styles.tab;
			const activityClass =
				type === "activity" ? styles.selectedTab : styles.tab;

			const headerClass = isSingleStudent
				? styles.bodyHeaderSingle
				: styles.bodyHeader;
			const headerEl = (
				<div className={styles.nameStats}>
					<StudentName studentData={studentData} />
					<div className={styles.printLogoWrapper}>
						<img
							className={styles.printLogo}
							src={AssetsUtil.getLogo("aops-ba")}
						/>
					</div>
					<div className={styles.stats}>
						<OfficeSummaryStats
							className={styles.statsInner}
							xp={studentData.xp}
							stars={studentData.stars}
							trophies={studentData.trophies}
							problemsCorrect={studentData.problemsCorrect}
							time={totalTime}
						/>
					</div>
				</div>
			);
			const allStudentsLink = isSingleStudent ? null : (
				<Link className={styles.all} to={URLMake.forParent()}>
					<span className={styles.bao}>h</span> All Students
				</Link>
			);

			if (forPrint) {
				return (
					<div>
						{headerEl}
						<div className={styles.report}>{body}</div>
					</div>
				);
			}

			let mainHeaderClass = styles.header;
			let bodyClass = styles.body;
			if (!OpsUser.hasAcceptedTerms(this.props.user)) {
				mainHeaderClass += " " + styles.disabled;
				bodyClass += " " + styles.disabled;
			}

			return (
				<div className={styles.mainInner}>
					{this.renderTermsAndConditions()}
					<div className={mainHeaderClass}>
						<div className={headerTitleClass}>
							<div className={styles.title}>
								<div className={styles.subtitle}>Report for</div>
								<div>{studentData.displayName}</div>
							</div>
							<AvatarLinkGroup
								key="avatarlinkgroup"
								className={linkClass}
								studentsData={studentsData}
								selectedID={studentID}
								extraAvatar={{
									imgSrc: AssetsUtil.getBeastAvatar("team"),
									label: "All Students",
									linkTo: URLMake.forParent(),
								}}
								isCentered={!fitAvatars}
								containerDims={this.props.containerDims}
							/>
						</div>
					</div>
					<div className={bodyClass}>
						<div className={headerClass}>
							{headerEl}
							<div className={styles.linksOuter}>
								{allStudentsLink}
								<div className={styles.tabs}>
									<Link
										className={progressClass}
										to={URLMake.forParentStudent(
											studentID,
											_.extend(
												{
													grade: _.get(
														studentData,
														"activity.lastPlayedData.gradeNumber"
													),
												},
												pageData,
												{type: "progress"}
											)
										)}
									>
										<span className={styles.bao}>E</span>Progress
									</Link>
									<Link
										className={activityClass}
										to={URLMake.forParentStudent(
											studentID,
											_.extend({}, pageData, {
												type: "activity",
											})
										)}
									>
										<span className={styles.bao}>A</span>Activity
									</Link>
								</div>
							</div>
						</div>
						<div className={styles.report}>{body}</div>
					</div>
					{problemModal}
				</div>
			);
		},

		render: function() {
			const requestLoad = () =>
				this.props.dispatch({
					type: AT.LOAD_PARENT_DATA_SLOT_REQUEST,
				});

			return (
				<div className={styles.main}>
					<LoadGuard
						identifier="officeParent"
						status={this.props.parentData}
						requestLoad={requestLoad}
						loadingView={"logo"}
						logoColorType={"color"}
						loadingViewClass={styles.loading}
						errorView="refreshOffice"
						renderLoaded={this.renderLoaded}
					/>
				</div>
			);
		},
	})
);
